import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const initSliderBlog = (id: string): void => {

  new Swiper(`${id} .swiper`, {
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: `${id} .swiper-button-next`,
      prevEl: `${id} .swiper-button-prev`
    },
    pagination: {
      el: `${id} .swiper-pagination`,
      clickable: true
    },
    loop: true
  });
};

export default initSliderBlog;
